import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  section: {
    padding: theme.spacing(1),
    width: '300px',
    flexShrink: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    border: '1px solid transparent',
    '&:has($header:hover)': {
      borderColor: '#d8dde1',
      borderRadius: '6px',
    },
  },
  header: {
    borderRadius: '6px',
  },
  bodyButton: {
    borderRadius: '6px',
    height: '100%',
  },
  body: {
    height: '100%',
  },
}));
